<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="Reports"
              icon="fas fa-list">
          </card-section-header>

          <div class="link-page-group" >
            <a *ngIf="showWorkerSessionsReport" [routerLink]="[urlBase + 'reports/worker-sessions']">
              <i class="fas fa-chart-bar"></i>
              Worker Sessions
            </a>

            <a *ngIf="showInductionReport" [routerLink]="[urlBase + 'reports/site-induction-report']">
              <i class="fas fa-file-contract"></i>
              Site Induction Report
            </a>

            <a *ngIf="showSiteFormReport" [routerLink]="[urlBase + 'reports/site-form-report']">
              <i class="fa fa-tasks"></i>
              Site Form Report
            </a>
            <a *ngIf="showRestrictionsReport" [routerLink]="[urlBase + 'reports/restrictions-report']">
              <i class="fas fa-exclamation-triangle"></i>
              Restrictions
            </a>
            <a *ngIf="showCompetencyAndTrainingReport" [routerLink]="[urlBase + 'reports/competency-reports']">
              <i class="far fa-calendar-check"></i>
              Competency and Training Reports
            </a>

            <a *ngIf="showRecentSiteSessionsCSV" href="javascript:void(0)" (click)="getSiteSessionsBackUp()">
              <i class="fas fa-magnifying-glass"></i>
              Worker Sessions Backup
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
